import React, { useEffect } from 'react';
import { twMerge } from 'tailwind-merge';

const BaseOverlay = ({ children, show, className }) => {
    useEffect(() => {
        if (show) {
            document.body.classList.add('overflow-hidden');
        }

        return () => {
            document.body.classList.remove('overflow-hidden');
        };
    }, [show]);

    return (
        <div>
            {show && <div className='fixed left-0 top-0 h-full w-full bg-black opacity-30 z-[1002]'></div>}
            <div
                className={twMerge(
                    `fixed bottom-0 left-0 w-full h-auto bg-white shadow-lg z-[1003] transform transition-transform duration-300 rounded-tl-3xl rounded-tr-3xl ${
                        show ? 'translate-y-0' : 'translate-y-full'
                    }`,
                    className
                )}
            >
                {children}
            </div>
        </div>
    );
};

export default BaseOverlay;
